import _regeneratorRuntime from "@babel/runtime/regenerator";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { concat, uint64be } from '../lib/buffer_utils.js';
import checkIvLength from '../lib/check_iv_length.js';
import checkCekLength from './check_cek_length.js';
import timingSafeEqual from './timing_safe_equal.js';
import { JOSENotSupported, JWEDecryptionFailed } from '../util/errors.js';
import crypto, { isCryptoKey } from './webcrypto.js';
import { checkEncCryptoKey } from '../lib/crypto_key.js';
import invalidKeyInput from '../lib/invalid_key_input.js';
import { types } from './is_key_like.js';

function cbcDecrypt(_x, _x2, _x3, _x4, _x5, _x6) {
  return _cbcDecrypt.apply(this, arguments);
}

function _cbcDecrypt() {
  _cbcDecrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(enc, cek, ciphertext, iv, tag, aad) {
    var keySize, encKey, macKey, macData, expectedTag, macCheckPassed, plaintext;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (cek instanceof Uint8Array) {
              _context2.next = 2;
              break;
            }

            throw new TypeError(invalidKeyInput(cek, 'Uint8Array'));

          case 2:
            keySize = parseInt(enc.slice(1, 4), 10);
            _context2.next = 5;
            return crypto.subtle.importKey('raw', cek.subarray(keySize >> 3), 'AES-CBC', false, ['decrypt']);

          case 5:
            encKey = _context2.sent;
            _context2.next = 8;
            return crypto.subtle.importKey('raw', cek.subarray(0, keySize >> 3), {
              hash: "SHA-".concat(keySize << 1),
              name: 'HMAC'
            }, false, ['sign']);

          case 8:
            macKey = _context2.sent;
            macData = concat(aad, iv, ciphertext, uint64be(aad.length << 3));
            _context2.t0 = Uint8Array;
            _context2.next = 13;
            return crypto.subtle.sign('HMAC', macKey, macData);

          case 13:
            _context2.t1 = _context2.sent.slice(0, keySize >> 3);
            expectedTag = new _context2.t0(_context2.t1);

            try {
              macCheckPassed = timingSafeEqual(tag, expectedTag);
            } catch (_a) {}

            if (macCheckPassed) {
              _context2.next = 18;
              break;
            }

            throw new JWEDecryptionFailed();

          case 18:
            _context2.prev = 18;
            _context2.t2 = Uint8Array;
            _context2.next = 22;
            return crypto.subtle.decrypt({
              iv: iv,
              name: 'AES-CBC'
            }, encKey, ciphertext);

          case 22:
            _context2.t3 = _context2.sent;
            plaintext = new _context2.t2(_context2.t3);
            _context2.next = 28;
            break;

          case 26:
            _context2.prev = 26;
            _context2.t4 = _context2["catch"](18);

          case 28:
            if (plaintext) {
              _context2.next = 30;
              break;
            }

            throw new JWEDecryptionFailed();

          case 30:
            return _context2.abrupt("return", plaintext);

          case 31:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[18, 26]]);
  }));
  return _cbcDecrypt.apply(this, arguments);
}

function gcmDecrypt(_x7, _x8, _x9, _x10, _x11, _x12) {
  return _gcmDecrypt.apply(this, arguments);
}

function _gcmDecrypt() {
  _gcmDecrypt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(enc, cek, ciphertext, iv, tag, aad) {
    var encKey;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(cek instanceof Uint8Array)) {
              _context3.next = 6;
              break;
            }

            _context3.next = 3;
            return crypto.subtle.importKey('raw', cek, 'AES-GCM', false, ['decrypt']);

          case 3:
            encKey = _context3.sent;
            _context3.next = 8;
            break;

          case 6:
            checkEncCryptoKey(cek, enc, 'decrypt');
            encKey = cek;

          case 8:
            _context3.prev = 8;
            _context3.t0 = Uint8Array;
            _context3.next = 12;
            return crypto.subtle.decrypt({
              additionalData: aad,
              iv: iv,
              name: 'AES-GCM',
              tagLength: 128
            }, encKey, concat(ciphertext, tag));

          case 12:
            _context3.t1 = _context3.sent;
            return _context3.abrupt("return", new _context3.t0(_context3.t1));

          case 16:
            _context3.prev = 16;
            _context3.t2 = _context3["catch"](8);
            throw new JWEDecryptionFailed();

          case 19:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[8, 16]]);
  }));
  return _gcmDecrypt.apply(this, arguments);
}

var decrypt = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(enc, cek, ciphertext, iv, tag, aad) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!isCryptoKey(cek) && !(cek instanceof Uint8Array))) {
              _context.next = 2;
              break;
            }

            throw new TypeError(invalidKeyInput.apply(void 0, [cek].concat(_toConsumableArray(types), ['Uint8Array'])));

          case 2:
            checkIvLength(enc, iv);
            _context.t0 = enc;
            _context.next = _context.t0 === 'A128CBC-HS256' ? 6 : _context.t0 === 'A192CBC-HS384' ? 6 : _context.t0 === 'A256CBC-HS512' ? 6 : _context.t0 === 'A128GCM' ? 8 : _context.t0 === 'A192GCM' ? 8 : _context.t0 === 'A256GCM' ? 8 : 10;
            break;

          case 6:
            if (cek instanceof Uint8Array) checkCekLength(cek, parseInt(enc.slice(-3), 10));
            return _context.abrupt("return", cbcDecrypt(enc, cek, ciphertext, iv, tag, aad));

          case 8:
            if (cek instanceof Uint8Array) checkCekLength(cek, parseInt(enc.slice(1, 4), 10));
            return _context.abrupt("return", gcmDecrypt(enc, cek, ciphertext, iv, tag, aad));

          case 10:
            throw new JOSENotSupported('Unsupported JWE Content Encryption Algorithm');

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function decrypt(_x13, _x14, _x15, _x16, _x17, _x18) {
    return _ref.apply(this, arguments);
  };
}();

export default decrypt;